<template>
  <md-sidenav class="main-sidebar md-left md-fixed" ref="leftSidenav">
    <md-toolbar class="md-large">
      <div class="md-toolbar-container">
        <img id="logo" src="../assets/logo_without.svg" />
        <h3 class="md-title">Shop Memo</h3>
      </div>
      <div class="md-toolbar-container">
        <div v-if="$root.currentUser">
          <md-avatar>
            <img
              v-if="$root.currentUser.providerData[0].photoURL"
              :src="$root.currentUser.providerData[0].photoURL"
              :alt="$root.currentUser.providerData[0].displayName"
            />
          </md-avatar>
          {{ $root.currentUser.providerData[0].displayName }}
        </div>
      </div>
    </md-toolbar>
    <div class="main-sidebar-content">
      <md-list class="md-triple-line" v-if="$root.userData">
        <md-list-item>
          <router-link v-bind:to="{ name: 'home' }">Home</router-link>
        </md-list-item>
        <md-list-item
          v-for="(value, key) in $root.userData.lists"
          v-bind:key="key"
        >
          <router-link v-bind:to="{ name: 'list', params: { id: key } }">{{
            value.name
          }}</router-link>
        </md-list-item>
        <md-list-item v-on:click.native="$refs.newListDialog.open"
          >Add new list</md-list-item
        >
      </md-list>
      <md-button
        class="md-primary"
        v-on:click.native="logout"
        v-if="$root.currentUser"
        >logout</md-button
      >
    </div>
    <md-dialog-prompt
      md-title="Create a new list"
      ref="newListDialog"
      md-input-placeholder="Name"
      v-model="listName"
      v-on:close="createNewList"
    ></md-dialog-prompt>
  </md-sidenav>
</template>

<script>
import { auth, db } from "@/helpers/firebase";
let listenForNewList = false;

export default {
  data() {
    return {
      listName: ""
    };
  },
  mounted() {
    this.$root.$on("toggleLeftSidenav", this.toggleLeftSidenav);
  },
  beforeDestroy() {
    this.$root.$off("toggleLeftSidenav", this.toggleLeftSidenav);
  },
  methods: {
    logout() {
      auth.signOut();
    },
    toggleLeftSidenav() {
      this.$refs.leftSidenav.toggle();
    },
    createNewList(type) {
      if (type === "ok" && this.listName) {
        db.child("users")
          .child(auth.currentUser.uid)
          .child("lists")
          .on("child_added", this.getNewListKey);
        db.child("users")
          .child(auth.currentUser.uid)
          .child("create_list")
          .set(this.listName)
          .then(() => {
            listenForNewList = true;
          });
      }
      this.listName = "";
    },
    getNewListKey(snapshot) {
      if (listenForNewList) {
        this.$router.push({ name: "list", params: { id: snapshot.key } });
        listenForNewList = false;
        db.child("users")
          .child(auth.currentUser.uid)
          .child("lists")
          .off("child_added", this.getNewListKey);
      }
    }
  }
};
</script>

<style></style>
